import styled from 'styled-components';

import { Sizes } from '../../../constants/sizes';

export interface IText {
    size?: Sizes;
    bold?: boolean;
}

export const Text = styled.p<IText>`
    color: ${({ theme }) => theme.colors.fontPrimary};
    font-weight: ${({ bold }) => (bold ? 'bold' : 'normal')};
    font-size: ${({ size, theme }) => {
        switch (size) {
            case Sizes.XS:
                return theme.fontSizes[0];
            case Sizes.S:
                return theme.fontSizes[1];
            case Sizes.M:
                return theme.fontSizes[2];
            case Sizes.L:
                return theme.fontSizes[3];
            case Sizes.XL:
                return theme.fontSizes[4];
            default:
                return theme.fontSizes[2];
        }
    }};
`;
